import { EventFragment } from "@/fragments/Event";
import { gql } from "@apollo/client";

export const EventsByTaxonomy = gql`
  ${EventFragment}
  query EventsByTaxonomy($taxonomies: [String] = [], $offset: Int = 0, $size: Int = 12, $language: String = "en") {
    events(
      where: {
        eventTypeFilters: $taxonomies,
        language: $language,
        afterToday: true,
        offsetPagination: {
          size: $size,
          offset: $offset
        }
      }
    ) {
      pageInfo {
        totalCount
        offsetPagination {
          hasMore
          hasPrevious
        }
      }
      nodes {
        ...EventFragment
      }
    }
  }
`;